export const FRAMEWORK_ICON_KEYS = [
    "ArrowRightLeft",
    "Axis3d",
    "Blocks",
    "BookOpen",
    "Bot",
    "Boxes",
    "Briefcase",
    "Building2",
    "Calculator",
    "Calendar",
    "CalendarRange",
    "ChartColumn",
    "Clock3",
    "Columns3",
    "Database",
    "FileText",
    "FolderKanban",
    "FolderTree",
    "Funnel",
    "Gauge",
    "GitBranch",
    "Hash",
    "HelpCircle",
    "Layers",
    "Layers3",
    "LayoutDashboard",
    "Link2",
    "LogIn",
    "MapPin",
    "MessageSquareText",
    "MonitorPlay",
    "Network",
    "Package",
    "PanelsTopLeft",
    "Pyramid",
    "Shapes",
    "SquareActivity",
    "SquareArrowRightEnter",
    "Table",
    "Table2",
    "Tag",
    "Tags",
    "Target",
    "TextCursorInput",
    "Timer",
    "User",
    "Users",
    "Wrench",
];
const FRAMEWORK_ICON_KEY_SET = new Set(FRAMEWORK_ICON_KEYS);
export function isFrameworkIconKey(value) {
    return FRAMEWORK_ICON_KEY_SET.has(value);
}
export function normalizeFrameworkIconKey(value) {
    if (!value)
        return null;
    return isFrameworkIconKey(value) ? value : null;
}
